export default {
  SET_USER(state, object) {
    state.user_tutor = object;
  },
  SET_TUTOR_LOCATION(state, object) {
    state.tutor_location = object;
  },
  TOGGLE_VISIBILITY(state) {
    state.sidebar_visible = Boolean(!state.sidebar_visible);
  },
  OFF_VISIBILITY(state) {
    state.sidebar_visible = false;
  },
  TOGGLE_NAVBAR_VISIBILITY(state) {
    state.navbar_visible = Boolean(!state.navbar_visible);
  },
  OFF_NAVBAR_VISIBILITY(state) {
    state.navbar_visible = false;
  },
  ON_NAVBAR_VISIBILITY(state) {
    state.navbar_visible = true;
  },
};



// WEBPACK FOOTER //
// ./src/store/user/mutations.js